import { Rate } from '../initializer';

export const DEFAULT_DAMPING = 0.006;
export const DEFAULT_BIND_EMITTER = true;
export const DEFAULT_EMITTER_RATE = new Rate(1, 0.1);
export const DEFAULT_BIND_EMITTER_EVENT = false;
export const DEFAULT_EMITTER_INDEX = undefined;
